import config from '@feature-config/finance/unified-accounts/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { UnifiedAccountsFeature } from './UnifiedAccountsFeature';

const unifiedAccountsFeature: FeatureModule = createFeatureModule(
  config,
  UnifiedAccountsFeature,
  'finance/unified-accounts'
);

export default unifiedAccountsFeature;
